var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusButton = function SvgPlusButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plus-button_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M7.981 5.25v3.057H4.924v2.038h3.057V13.4h2.038v-3.056h3.057V8.307h-3.057V5.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus-button_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPlusButton;